import {
  Ban,
  Crosshair,
  FileCode,
  FileText,
  Scan,
  ScanLine,
} from 'lucide-react';

import { ExceptionPending } from './ExceptionPending';

export const AsvIcons = {
  Product: ScanLine,
  Target: Crosshair,
  Scan,
  Exception: Ban,
  ExceptionPending,

  ExecutiveSummary: FileText,
  Json: FileCode,
};
